import React, { useState } from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TabPanel from '../../TabPanel';
import { Banner } from './Bannerv2';
import Customizations from './Customizations';
import ViewMode from './viewMode';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

const Layout: React.FC = () => {
  const classes_root = useStyles();

  const [tab, setTab] = useState(0);

  interface a11yPropsReturnType {
    id: string;
    'aria-controls': string;
  }

  function a11yProps(index: number): a11yPropsReturnType {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }

  return (
    <div className={classes_root.root} id="teste">
      <AppBar position="static" color="transparent">
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="config_tabs"
        >
          <Tab label="Modo de visualização" {...a11yProps(0)} />
          <Tab label="Banner" {...a11yProps(1)} />
          <Tab label="Personalização" {...a11yProps(2)} />
        </Tabs>
      </AppBar>

      <TabPanel
        value={tab}
        index={0}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <ViewMode />
      </TabPanel>

      <TabPanel value={tab} index={1}>
        <Banner />
      </TabPanel>

      <TabPanel
        value={tab}
        index={2}
        containerStyle={{ maxWidth: 'initial', padding: 0, margin: 0 }}
      >
        <Customizations />
      </TabPanel>
    </div>
  );
};

export default Layout;
